
















import { Vue, Component, Prop } from "vue-property-decorator";
import { VIPCapabilityRequest, VipCapabilityRequestStatus } from "@/loader";

@Component
export default class CapabilityRequestStatusBadge extends Vue {
	@Prop({ type: VIPCapabilityRequest, default: null })
	public item!: VIPCapabilityRequest | null;

	@Prop({ type: Boolean, default: false })
	public hideText!: boolean;

	@Prop({ type: Boolean, default: false })
	public hideIcon!: boolean;

	@Prop({ type: Boolean, default: false })
	public button!: boolean;

	@Prop({ type: [String, Object], default: null })
	public to!: string | Location | null;

	public get title(): string {
		return this.item ? this.item.getStatusLabel() : "";
	}

	public get icon(): string | string[] | null {
		switch (this.item?.status) {
			case VipCapabilityRequestStatus.sent:
				return ["far", "envelope"];
			case VipCapabilityRequestStatus.answered:
				return ["fas", "check"];
			case VipCapabilityRequestStatus.draft:
			default:
				return ["fas", "edit"];
		}
	}

	public get statusVariant(): string {
		switch (this.item?.status) {
			case VipCapabilityRequestStatus.answered:
				return "success";
			case VipCapabilityRequestStatus.sent:
				return "warning";
			case VipCapabilityRequestStatus.draft:
			default:
				return "info";
		}
	}
}
